import React from 'react';

const ConsentModal = ({ isOpen, onAccept, onDecline, recipientName, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 animate-fadeIn">
        {/* Close button */}
        <button
          onClick={onClose}
          className="float-right text-gray-400 hover:text-gray-600 text-2xl font-bold"
          aria-label="Close modal"
        >
          &times;
        </button>

        <div className="text-center">
          <div className="text-5xl mb-4">🎁</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Want help finding the perfect gift?
          </h2>

          <p className="text-gray-700 mb-4">
            We can send you personalized product suggestions within your budget
            {recipientName && (
              <>
                {' for '}
                <strong>{recipientName}</strong>
              </>
            )}
            .
          </p>

          {/* Affiliate Disclosure Box */}
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4 text-left">
            <p className="text-sm text-yellow-800">
              <span className="font-semibold">ⓘ Affiliate Disclosure:</span> Suggestions will include affiliate links.
              We may earn a commission if you make a purchase at no extra cost to you.
            </p>
          </div>

          <p className="text-sm text-gray-600 mb-6">
            Click <strong>Yes</strong> to receive suggestions by email.
            You can unsubscribe anytime.
          </p>

          {/* Buttons */}
          <div className="space-y-3">
            <button
              onClick={onAccept}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition transform hover:scale-105 shadow-lg"
            >
              ✅ Yes, send me suggestions
            </button>

            <button
              onClick={onDecline}
              className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-3 px-6 rounded-lg transition"
            >
              ❌ No thanks
            </button>
          </div>

          {/* Privacy Note */}
          <p className="text-xs text-gray-500 mt-4">
            Your data is handled in accordance with our{' '}
            <a href="/privacy-policy" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>{' '}
            and GDPR/CCPA regulations.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal;
